<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form v-if="show">
        <span>
          <label class="vs-select--label">{{ $t("Product") }}</label>
          <treeselect
            class="mb-4"
            v-model="model.actualProductId"
            :multiple="false"
            :placeholder="$t('Search')"
            :async="true"
            :load-options="loadOptions"
            name="actualProduct"
            v-validate="{ required: true }"
          />
          <span
            class="text-danger text-sm mt-4"
            v-show="errors.has('actualProduct')"
            >{{ errors.first("actualProduct") }}</span
          >
        </span>
        <span>
          <label class="vs-select--label">{{ $t("Warranty") }}</label>
          <v-select
            label="childNameWithParentName"
            name="warranty"
            :options="warrantyList"
            ref="warrantyListSelect"
            :reduce="(x) => x.id"
            v-model="model.warrantyId"
            v-validate="{ required: true }"
            class="mb-4"
            dir="rtl"
            @keyup.tab="goToItemCodePartial(1)"
          >
          </v-select>
          <span
            class="text-danger text-sm mt-4"
            v-show="errors.has('warranty')"
            >{{ errors.first("warranty") }}</span
          >
        </span>
        <span>
          <label class="vs-select--label">{{ $t("ItemCode") }}</label>
          <div
            class="vx-row w-9/12 md:w-4/12 sm:w-6/12 p-0 mx-0 vs-input--input vs-input--input.normal"
          >
            <vs-input
              class="vs-input-no-border w-1/4"
              v-model="itemCode4"
              id="itemCode4"
              ref="itemCode4"
              name="code"
              maxlength="3"
              placeholder="کد کالا"
            />
            <span style="color: red; font-size: 18px" class="pt-2 mx-2">-</span>
            <vs-input
              class="vs-input-no-border w-1/6"
              v-model="itemCode3"
              id="itemCode3"
              ref="itemCode3"
              name="code"
              maxlength="2"
              placeholder="محصول"
            />
            <span style="color: red; font-size: 18px" class="pt-2 mx-2">-</span>
            <vs-input
              class="vs-input-no-border w-1/6"
              v-model="itemCode2"
              id="itemCode2"
              ref="itemCode2"
              name="code"
              maxlength="2"
              placeholder="دسته"
            />
            <span style="color: red; font-size: 18px" class="pt-2 mx-2">-</span>
            <vs-input
              class="vs-input-no-border w-1/6"
              v-model="itemCode1"
              id="itemCode1"
              ref="itemCode1"
              name="code"
              maxlength="2"
              placeholder="برند"
            />
          </div>
        </span>
        <span class="mt-4 text-danger text-sm" v-show="MultipleTwo">{{
          errorsItemCode
        }}</span>

        <vs-input
          class="inputx mb-4"
          v-model="model.modelNumber"
          name="modelNo"
          :label="$t('ModelNumber')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('modelNo')">{{
          errors.first("modelNo")
        }}</span>
        <vs-input
          class="inputx mb-4"
          v-model="model.identificationCode"
          @input="acceptAndSetNumbers($event, 'identificationCode')"
          v-validate="{ required: true }"
          name="identificationCodeErrorMessage"
          :label="$t('IdentificationCode')"
        />
        <span
          class="text-danger text-sm mt-4"
          v-show="errors.has('identificationCodeErrorMessage')"
          >{{ errors.first("identificationCodeErrorMessage") }}</span
        >
        <vs-input
          class="inputx mb-4"
          v-model="model.guaranteeIdentification"
          @input="acceptAndSetNumbers($event, 'guaranteeIdentification')"
          v-validate="{ required: true }"
          name="guranteeIdentificationErrorMessage"
          :label="$t('guranteeIdentification')"
        />
        <span
          class="text-danger text-sm mt-4"
          v-show="errors.has('guranteeIdentificationErrorMessage')"
          >{{ errors.first("guranteeIdentificationErrorMessage") }}</span
        >
        <span>
          <label class="vs-select--label">{{ $t("Color") }}</label>
          <v-select
            label="name"
            name="color"
            :options="colorList"
            ref="colorListSelect"
            :reduce="(x) => x.id"
            v-model="model.productColorId"
            v-validate="{ required: true }"
            class="mb-4"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm mt-4" v-show="errors.has('color')">{{
            errors.first("color")
          }}</span>
        </span>
        <span>
          <label class="vs-select--label">{{ $t("ProducingCountry") }}</label>
          <v-select
            label="name"
            name="country"
            :options="countryList"
            ref="countryListSelect"
            :reduce="(x) => x.id"
            v-model="model.countryId"
            v-validate="{ required: true }"
            class="mb-4"
            dir="rtl"
          >
          </v-select>
          <span
            class="text-danger text-sm mt-4"
            v-show="errors.has('country')"
            >{{ errors.first("country") }}</span
          >
          <vs-input
            class="inputx mb-4 mb-4"
            v-model="model.description"
            name="description"
            :label="$t('Description')"
          />
        </span>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="!isComplete"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .vs-con-input input {
  text-align: right;
}
::v-deep .text-danger {
  position: relative;
  top: -10px;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const dict = {
  custom: {
    color: {
      required: "لطفا نام رنگ را انتخاب نمایید.",
    },
    country: {
      required: "لطفا نام کشور را انتخاب نمایید.",
    },
    warranty: {
      required: "لطفا گارانتی را انتخاب نمایید.",
    },
    modelNo: {
      required: "لطفا مدل نامبر را وارد نمایید.",
    },
    actualProduct: {
      required: "لطفا نام محصول را انتخاب نمایید.",
    },
    identificationCodeErrorMessage: {
      required: "لطفا شناسه محصول را انتخاب نمایید.",
    },
    guranteeIdentificationErrorMessage: {
      required: "لطفا شناسه گارانتی محصول را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: false,
    model: {
      default: {},
    },
    keywords: {},
    colorList: {},
    countryList: {},
    warrantyList: {},
  },
  components: {
    "v-select": vSelect,
    Treeselect,
  },
  data() {
    return {
      errorsItemCode: "کد کالا باید مضربی از دو باشد.",
      popupTitle: "",
      InputElement: null,
      itemCode: "",
      itemCode1: "",
      itemCode2: "",
      itemCode3: "",
      itemCode4: "",
      MultipleTwo: false,
      modelFinally: {},
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
    isComplete() {
      if (
        this.model.warrantyId &&
        this.model.actualProductId &&
        this.model.modelNumber &&
        this.model.identificationCode &&
        this.model.guaranteeIdentification &&
        this.model.productColorId &&
        this.model.countryId
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      createSpecificProduct: "specificProduct/create",
      updateSpecificProduct: "specificProduct/update",
      fetchSearch: "actualProduct/fetchSearch",
    }),
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label: element.persianName,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    resetForm() {
      this.model = {};
      this.modelFinally = {};
      this.itemCode = "";
      this.itemCode1 = "";
      this.itemCode2 = "";
      this.itemCode3 = "";
      this.itemCode4 = "";
      this.$validator.reset();
      this.$refs.warrantyListSelect.clearSelection();
      this.$refs.colorListSelect.clearSelection();
      this.$refs.countryListSelect.clearSelection();
    },
    createModel() {
      this.modelFinally = {
        actualProductId: this.model.persianName,
        description: this.model.description,
        countryId: this.model.countryId,
        countryName: this.model.countryName,
        warrantyId: this.model.warrantyId,
        productColorId: this.model.productColorId,
        itemCode: this.itemCode,
        identificationCode: this.model.identificationCode,
        guaranteeIdentification: this.model.guaranteeIdentification,
        modelNumber: this.model.modelNumber,
      };
    },
    finallyMessageSuccess() {
      this.$swal({
        position: "center-center",
        type: "success",
        text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
        showConfirmButton: false,
        timer: 2000,
      });
      this.$emit("finish");
      this.resetForm();
    },
    setActualProductInModel() {
      if (this.model.actualProductNamePrevious == this.model.actualProductId) {
        this.modelFinally.actualProductId = this.model.actualProductIdPrevious;
      } else {
        this.modelFinally.actualProductId = this.model.actualProductId;
      }
    },
    apiCallDueToCondition() {
      this.createModel();
      if (this.model.id != null) {
        this.modelFinally.id = this.model.id;
        this.setActualProductInModel();
        this.updateSpecificProduct(this.modelFinally).then(() => {
          this.finallyMessageSuccess();
        });
      } else {
        this.createSpecificProduct(this.model).then(() => {
          this.finallyMessageSuccess();
        });
      }
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result && !this.MultipleTwo) {
          this.model.countryName = this.countryList.find(
            (x) => x.id == this.model.countryId
          ).name;
          this.itemCode =
            this.itemCode1 + this.itemCode2 + this.itemCode3 + this.itemCode4;
          this.model.itemCode = this.itemCode;
          if (!this.itemCode) {
            this.$swal({
              title:
                "با توجه به اینکه شما کد کالا را وارد نکرده‌اید ، کد کالا به صورت اتوماتیک تکمیل میگردد.",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "تایید",
              cancelButtonText: "وارد کردن کد کالا",
            }).then((result) => {
              if (result.value) {
                this.apiCallDueToCondition();
              }
            });
          } else {
            this.apiCallDueToCondition();
          }
        }
      });
    },
    goToItemCodePartial(i) {
      this.InputElement = document.getElementById("itemCode" + i);
      this.InputElement.focus();
      this.MultipleTwo = false;
    },
    setItemcodeInStrucher() {
      if (this.model.itemCode.length > 1) {
        this.itemCode1 = this.model.itemCode.slice(0, 2);
        this.model.itemCode = this.model.itemCode.slice(2);
        if (this.model.itemCode.length > 1) {
          this.itemCode2 = this.model.itemCode.slice(0, 2);
          this.model.itemCode = this.model.itemCode.slice(2);
          if (this.model.itemCode.length > 1) {
            this.itemCode3 = this.model.itemCode.slice(0, 2);
            this.model.itemCode = this.model.itemCode.slice(2);
            if (this.model.itemCode.length > 1) {
              this.itemCode4 = this.model.itemCode.slice(0, 2);
              this.model.itemCode = this.model.itemCode.slice(2);
            }
          }
        }
      }
    },
    acceptAndSetNumbers(event, property) {
      this.model[property] = event.replace(/\D/g, "");
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.resetForm();
        if (this.model.itemCode) {
          this.setItemcodeInStrucher();
        }
        if (this.model.id) {
          this.popupTitle = "EditItem";
        } else {
          this.popupTitle = "CreateNewItem";
        }
      }
      this.$validator.reset();
    },
    itemCode1(value) {
      if (value) {
        if (value.length == 2) {
          this.goToItemCodePartial(2);
        } else this.MultipleTwo = true;
      }
    },
    itemCode2(value) {
      if (value) {
        if (value.length == 2) {
          this.goToItemCodePartial(3);
        } else this.MultipleTwo = true;
      } else this.goToItemCodePartial(1);
    },
    itemCode3(value) {
      if (value) {
        if (value.length == 2) {
          this.MultipleTwo = false;
          this.goToItemCodePartial(4);
        } else this.MultipleTwo = true;
      } else this.goToItemCodePartial(2);
    },
    itemCode4(value) {
      if (value) {
        if (value.length == 3) {
          this.MultipleTwo = false;
        } else this.MultipleTwo = true;
      } else this.goToItemCodePartial(2);
    },
  },
};
</script>
